<template>
    <section id="StudentGrades" class="grades card">
        <h2 id="grades-header" class="card-header">
            <a id="gradesanchor" name="gradesanchor"></a>
            <button class="btn btn-link" data-toggle="collapse" data-target=".grades-card-body" aria-expanded="true" aria-controls="grades-card-body" @click="collapsePanel" aria-label="Toggle Grade Section (Mobile View)">
                <span v-if="gradesAreLoaded == 1">
                    <span class="icon icon-star"></span>{{currentTerm.key.replace("- Urbana-Champaign", "")}} Grades
                </span>
                <span v-else>
                    <span class="icon icon-star"></span>Loading Grades...
                </span>
            </button>
        </h2>
        <div id="gradeContent" class="grades-card-body card-body collapse" aria-labelledby="grades-header">
            <div v-if="gradesAreLoaded == 1">
                <div v-if="!hasHold">
                    <div class="block block-top" v-if="notNullOrEmpty(termList)">
                        <div class="form-group">
                            <label for="TermCode">Change term:</label>
                            <select id="TermCode" class="grades_term_code form-control" v-model="termCode">
                                <option v-for="item in termList" :value="item.value" :key="item.value">
                                    {{item.key}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div v-if="!notNullOrEmpty(gradesByTerm)">
                        <p>You do not have any grades for this term.</p>
                    </div>
                    <div v-else>
                        <div v-for="(course, index) in gradesByTerm" :key="index">
                            <div class="course block">
                                <h3>{{course.courseTitle}} <span class="grade">{{notNullOrEmpty(course.gradeInAcadHistory) ? course.gradeInAcadHistory : "Grade Pending"}}</span></h3>
                                <p>{{course.subject.code}} {{course.courseNumber}} {{course.sequenceNumber}} ({{course.crn}}) {{course.creditHour}} hrs</p>         
                            </div> 
                        </div>
                    </div>
                    <div class="additinal-grade-info block block-bottom">
                        <p><a :href="selfServiceGradesPath" target="_blank">View this in Self-Service</a></p>
                    </div>
                
                </div>
                <div v-else>
                    <p>There is at least one hold preventing you from viewing your grades.</p>
                </div>
            </div>
            <div v-else>
                <div v-if="gradesAreLoaded == 2">
                        <p>We are having trouble loading this section. This could be because we can't find a record for you or we are having connectivity problems.</p>
                </div>
                <div v-else>
                    <spinner></spinner>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
    import { isNullOrUndefined } from 'util';
    import spinner from "../components/spinner.vue";
    import { getSelfServiceGradesUrl } from "@/common/envMixins";
    export default {
        name: "StudentGrades",
        components: {spinner},
        computed : {
            gradesAreLoaded() { return this.$store.state.gradesAreLoaded },
            hasHold() { return this.$store.state.studentGrades.hasHold },
            termCode: { 
                get() {
                    return this.$store.state.studentGrades.defaultTermCode 
                },
                set(value) {
                    const stuGrades = this.$store.state.studentGrades;
                    stuGrades.defaultTermCode = value;
                    this.$store.commit("setGrades", stuGrades);
                }
            },
            termList() {
                const thisGrades = this.grades;
                const result = Array.from(new Set(thisGrades.map(x => x.term.code))).map(tCode => {
                    return {
                        key: thisGrades.find(x => x.term.code == tCode).term.description,
                        value: tCode
                    }
                });
                return result;
            },
            currentTerm() {
                let filteredTerms = this.termList.filter(x => x.value == this.termCode);
                if (isNullOrUndefined(filteredTerms) || filteredTerms.length == 0) {
                    return this.termList[0];
                } else {
                    return this.termList.filter(x => x.value == this.termCode)[0];
                }        
            },
            grades () { return this.$store.state.studentGrades.grades},
            gradesByTerm() {
                let thisTerm = this.termCode;
                return this.grades.filter(x=> x.term.code == thisTerm);
            },
            selfServiceGradesPath() { return getSelfServiceGradesUrl()} 
        },
        mounted() {
            if (this.$store.state.gradesAreLoaded == 0) {
                this.$store.dispatch("getGrades");
            }
        }
    }
</script>